export default __webpack_public_path__ + "static/media/image-check.dbad48c3.svg";